// @arc/brief-schema
//
// TypeScript mirror of CoachBriefV2 defined in the arc iOS repo at
// LLM/CoachBriefV2.swift. This file is the single source of truth for the
// packet shape on the web clients (dashboard + Chrome extension).
//
// Keep in lockstep with the Swift model. Schema-shape changes MUST bump
// CURRENT_SCHEMA_VERSION here and CoachBriefV2.currentSchemaVersion in
// Swift together, and extend the transport round-trip test in
// packages/brief-schema/tests.
//
// No portable exports. PDF / text share are NOT user-facing surfaces. The
// debug text renderer in Swift is behind an internal feature flag and must
// never be ported to the web clients.
export const CURRENT_SCHEMA_VERSION = 2;
/**
 * Normalize the snake_case RPC shape into the camelCase client shape.
 * Does NOT fetch. Pure transform. The RPC response must already have been
 * trimmed server-side to at most 3 facts; we clamp again here as a
 * defense-in-depth guard.
 */
export function normalizeUnauthPreview(server) {
    return {
        packetId: server.packet_id,
        generatedAt: server.generated_at,
        studentDisplayName: server.student_display_name,
        sessionLabel: server.session_label,
        club: server.club,
        dataConfidence: server.data_confidence,
        title: server.title,
        oneLineRead: server.one_line_read,
        topFacts: server.top_facts.slice(0, 3),
    };
}
// ---------------------------------------------------------------------------
// Constants consumed by both clients
// ---------------------------------------------------------------------------
/**
 * Allow-listed fields the server is permitted to return via the unauth
 * preview RPC. Defense-in-depth check in clients before render: any key
 * outside this set should be dropped and reported.
 */
export const UNAUTH_PREVIEW_ALLOWED_KEYS = [
    "packet_id",
    "generated_at",
    "student_display_name",
    "session_label",
    "club",
    "data_confidence",
    "title",
    "one_line_read",
    "top_facts",
];
/**
 * Sample role labels for the Coach Brief UI. Source of truth is the Swift
 * model; keep these strings aligned.
 */
export const SAMPLE_ROLE_LABEL = {
    best_stock: "Best stock rep",
    typical_miss: "Typical miss",
    fatigue_rep: "Fatigue rep",
    pressure_rep: "Pressure rep",
};
/**
 * Display labels for provenance badges. Renderers should show these adjacent
 * to every Measurement per spec Required Provenance Labels.
 */
export const PROVENANCE_LABEL = {
    measured: "Measured",
    estimated: "Estimated",
    proxy: "Proxy",
    insufficient: "Insufficient data",
};
